module.exports = __webpack_public_path__ + "static/srxp-cover-c9589d5294db55ca559781306d5a22b4.png";